<template>
  <v-dialog v-model="value" :width="width" persistent autofocus>
    <v-card>
      <v-card-title primary-title class="px-2 py-1 mb-4 grey4">
        <div class="px-2 font-weight-bold">{{ $t("app_shortcuts") }}</div>
        <v-spacer />
        <v-btn
          class="ma-0"
          icon
          @click="$emit('input', false)"
          :focusable="false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout row wrap class="px-4 pt-1 pb-3">
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("cash_receipts") }} =
          </span>
          <code>ALT</code> + <code>⬆</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("cash_payments") }} =
          </span>
          <code>ALT</code> + <code>⬇</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2">{{ $t("exchanges") }} = </span>
          <code>ALT</code> + <code>➡</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("a2a_transfers") }} =
          </span>
          <code>ALT</code> + <code>⬅</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("send_transfers") }} =
          </span>
          <code>ALT</code> + <code>T</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("receive_transfers") }} =
          </span>
          <code>ALT</code> + <code>R</code>
        </div>
        <v-divider class="flex xs12 my-2" />
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2">{{ $t("dashboard") }} = </span>
          <code>CTRL</code> + <code>ALT</code> + <code>D</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("general_ledger") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>1</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2">{{ $t("lctr_report") }} = </span>
          <code>CTRL</code> + <code>ALT</code> + <code>2</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("income_statement") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>3</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("balance_sheet") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>4</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("transactions_report") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>5</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("individuals_report") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>6</code>
        </div>
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("corporates_report") }} =
          </span>
          <code>CTRL</code> + <code>ALT</code> + <code>7</code>
        </div>
        <v-divider class="flex xs12 my-2" />
        <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("account_to_search") }} =
          </span>
          <code>CTRL</code> + <code>SPACE</code>
        </div>
         <div class="flex xs12 sm6 px-1 py-2">
          <span class="font-weight-bold mx-2"
            >{{ $t("app_shortcuts") }} =
          </span>
          <code>CTRL</code> + <code>SHIFT</code> + <code>S</code>
        </div>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      required: true,
    },
    width: {
      default: "1000px",
    },
  },
};
</script>